module.exports = __webpack_public_path__ + "img/icon_back_circle.773d3364.png";